import { Edit, SaveButton, Toolbar } from 'react-admin';
import { GoogleAdsBridgesForm } from './GoogleAdsBridges.Form';
import { BackButton } from '../../../helperComponents/BackButton';
import { stripSecret } from '../../../../helpers/googleAdsBridgesHelpers';

const GoogleAdsBridgesEditToolbar = () => (
  <Toolbar>
    <SaveButton />
  </Toolbar>
);

export const GoogleAdsBridgesEdit = (props) => {
  return (
    <>
      <BackButton path="/google_ads_bridges" />
      <span className="h4">Edit Connected Account</span>
      <Edit {...props} title=" " redirect={false} mutationMode="pessimistic" transform={stripSecret}>
        <GoogleAdsBridgesForm isEdit={true} toolbar={<GoogleAdsBridgesEditToolbar />} />
      </Edit>
    </>
  );
};
